import { takeLatest, takeEvery, put, call } from "redux-saga/effects";
import apiCall from "../services"
import config from '../config/config.json';


function* passenger(actions) {

    try {
      
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };
        
        let url = (actions.query === null) ? config.credentials.url + '/pax/' : config.credentials.url + '/pax/' + actions.query
        
        const response = yield call(apiCall, 'get', url, requestOptions)
     
        yield put({ type: "PASSENGER_RESPONSE", value: response })

    } catch (error) {
        yield put({ type: "PASSENGER_RESPONSE", value: error })
    }
}


function* passengers(actions) {

    try {
        
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };
        
        let url = (actions.query === null) ? config.credentials.url + '/pax/?offset=0&limit='+actions.limit : config.credentials.url + '/pax/' + actions.query

        const response = yield call(apiCall, 'get', url, requestOptions)

        yield put({ type: "PASSENGERS_RESPONSE_LIST", value: response })

    } catch (error) {
        yield put({ type: "PASSENGERS_RESPONSE_LIST", value: error })
    }
}


function* add(actions) {

    try {

        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };
        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data)
        };

        const response = yield call(apiCall, 'POST',config.credentials.url+'/pax/', requestOptions);

        yield put({ type: "PASSENGER_RESPONSE", value: response })

    } catch (error) {
        yield put({ type: "PASSENGER_RESPONSE", value: error })
    }
}


function* remove(actions) {

    try {

        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };
 
        const requestOptions = {
            headers: headers
        };
 

        const response = yield call(apiCall, 'delete', config.credentials.url+ '/pax/' + actions.data+ '/', requestOptions)
     
        yield put({ type: "PASSENGER_RESPONSE", value: response})
 
    } catch (error) {
        yield put({ type: "PASSENGER_RESPONSE", value: error })
    }
}


function* edit(actions) {

    try {
      
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };
 
        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data)
        };

        const response = yield call(apiCall, 'put', config.credentials.url+ '/pax/' + actions.id+ '/', requestOptions)
 
        yield put({ type: "PASSENGER_RESPONSE", value: response})
 
    } catch (error) {
        yield put({ type: "PASSENGER_RESPONSE", value: error })
    }
}


function* passengerByDoc(actions) {

    try {
      
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };
        
        let url = config.credentials.url + '/pax/?doc_number=' + actions.query + '&limit=1/';
        
        const response = yield call(apiCall, 'get', url, requestOptions)
     
        yield put({ type: "PASSENGER_RESPONSE", value: response })

    } catch (error) {
        yield put({ type: "PASSENGER_RESPONSE", value: error })
    }
}


export function* getPassenger() {
    yield takeEvery("GET_PASSENGER", passenger)
}
export function* getPassengersList() {
    yield takeEvery("GET_PASSENGERS", passengers)
}

export function* addPassenger() {
    yield takeEvery("ADD_PASSENGER", add)
}

export function* removePassenger() {
    yield takeEvery("REMOVE_PASSENGER", remove)
}

export function* editPassenger() {
    yield takeEvery("EDIT_PASSENGER", edit)
}

export function* getPassengerByDoc() {
    yield takeEvery("GET_PASSENGER_BY_DOC", passengerByDoc)
}
